function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H30V30H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1d1d1d",
  d: "M19.867 74.815l-2.2-4.233a2.257 2.257 0 0 0-2.042-1.206H4.351a2.243 2.243 0 0 0-2.042 1.206l-2.2 4.212A.915.915 0 0 0 0 75.2v5.693a1.866 1.866 0 0 0 1.909 1.82h16.182A1.866 1.866 0 0 0 20 80.889v-5.672a1.087 1.087 0 0 0-.133-.402zm-6.016-.508a.959.959 0 0 0-.932.72 3.03 3.03 0 0 1-5.9 0 .923.923 0 0 0-.932-.72h-3.6l1.532-2.921a.438.438 0 0 1 .333-.212h11.275a.352.352 0 0 1 .333.212l1.509 2.921z",
  transform: "translate(5 -61.042)"
});

function SvgIconTrayBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrayBlack);
export default __webpack_public_path__ + "static/media/iconTrayBlack.44c291c3.svg";
export { ForwardRef as ReactComponent };